import { render, staticRenderFns } from "./PracticeUpdatedDate.vue?vue&type=template&id=1d4922f2&"
import script from "./PracticeUpdatedDate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PracticeUpdatedDate.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4922f2')) {
      api.createRecord('1d4922f2', component.options)
    } else {
      api.reload('1d4922f2', component.options)
    }
    module.hot.accept("./PracticeUpdatedDate.vue?vue&type=template&id=1d4922f2&", function () {
      api.rerender('1d4922f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/PracticeUpdatedDate.vue"
export default component.exports